import i18n from '@/utils/i18n';
import React from 'react';
import {
  CHECK_IN_TAG_INTERACTIONS,
  CHECK_IN_TAGS,
  CheckInTag,
} from '@/experiences/sales-portal/domain/accounts/screens/account-detail/containers/account-detail-check-in/constants';
import { Chip } from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { CRM_CHECK_IN_INTERACTION_LABEL_KEYS } from '@/experiences/sales-portal/blocs/utils/crm-check-in-interactions';
import { Pressable, View } from 'react-native';

interface CheckInTagRowProps {
  onToggleTag: (tag: CheckInTag) => void;
  selectedTags: CheckInTag[];
}

export const CheckInTagRow: React.FC<CheckInTagRowProps> = ({
  onToggleTag,
  selectedTags,
}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.row}>
      {CHECK_IN_TAGS.map((tag) => {
        const label = i18n.t(
          CRM_CHECK_IN_INTERACTION_LABEL_KEYS[CHECK_IN_TAG_INTERACTIONS[tag]],
        );
        const selected = selectedTags.includes(tag);
        return (
          <Pressable
            accessibilityLabel={label}
            accessibilityRole="checkbox"
            aria-checked={selected}
            key={tag}
            onPress={() => onToggleTag(tag)}
          >
            <Chip circular pressable selected={selected} size="$md">
              <Chip.Text>{label}</Chip.Text>
            </Chip>
          </Pressable>
        );
      })}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.sk.spacing.spaceSmall,
  },
}));
